"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross4"));
var _isEmail = _interopRequireDefault(require("validator/lib/isEmail"));
var _DataConnectorsPicker = _interopRequireDefault(require("../DataConnectorsPicker"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var actions = [{
  value: 'none',
  label: 'No message'
}, {
  value: 'email',
  label: 'Send email'
}, {
  value: 'sms',
  label: 'Send sms'
}];
var schedules = [{
  value: 'immediately',
  label: 'Immediately'
}, {
  value: 'digest',
  label: 'Once daily'
}];
var validate = exports.validate = function validate(values) {
  var _values$definition;
  var errors = {};
  if (!values.name) {
    errors.name = 'Name is required';
  }
  if (!((_values$definition = values.definition) !== null && _values$definition !== void 0 && _values$definition.aggregation)) {
    errors.definition = 'Condition is required';
  }
  if (values.subscriberType === 'email') {
    values.emails.forEach(function (email, index) {
      if (!(0, _isEmail["default"])(email)) {
        errors["emails.".concat(index)] = 'Wrong email';
      }
    });
  }
  if (values.subscriberType === 'sms') {
    values.phones.forEach(function (phone, index) {
      if (!/^\d{10}$/.test(phone)) {
        errors["phones.".concat(index)] = 'Phone should contain exactly 10 digits';
      }
    });
  }
  return errors;
};
var FlagForm = function FlagForm(props) {
  var initialValues = props.initialValues,
    onSubmit = props.onSubmit,
    closeModal = props.closeModal;
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: _objectSpread({
      name: '',
      description: '',
      definition: {},
      subscriberType: 'none',
      schedule: 'immediately',
      emails: [''],
      phones: ['']
    }, initialValues),
    validate: validate,
    onSubmit: (/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return onSubmit(values);
            case 1:
              closeModal();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()),
    render: function render(_ref2) {
      var values = _ref2.values,
        errors = _ref2.errors;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].introduction
      }, "Response flags are evaluated upon the respondent\u2019s completion of the Quest. Changes to the flag settings or underlying metrics or formulas will not result in any flags being assigned or removed to existing responses."), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "name",
        component: _cccisdFormik.CccisdInput,
        label: "Name"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "description",
        label: "Description",
        component: _cccisdFormik.CccisdTextarea,
        style: {
          height: '7em'
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "definition",
        component: _cccisdFormik.CccisdCondition,
        label: "Condition to trigger flag",
        DataConnectorsPicker: _DataConnectorsPicker["default"]
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, "Messages when triggered"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].block
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "subscriberType",
        component: _cccisdFormik.CccisdSelect,
        label: "",
        options: actions
      }), values.subscriberType !== 'none' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "schedule",
        component: _cccisdFormik.CccisdSelect,
        label: "",
        options: schedules
      }))), values.subscriberType === 'email' && /*#__PURE__*/_react["default"].createElement("div", {
        className: "card border-primary mb-3"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-header text-bg-primary"
      }, "Receiver List (", values.emails.length, ")"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-body"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
        name: "emails",
        render: function render(arrayHelpers) {
          return /*#__PURE__*/_react["default"].createElement("div", null, values.emails.map(function (item, index, arr) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: index,
              className: _style["default"].block
            }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "emails.".concat(index),
              component: _cccisdFormik.CccisdInput,
              label: "",
              autoFocus: index === arr.length - 1,
              style: {
                width: '24em'
              }
            }), /*#__PURE__*/_react["default"].createElement("button", {
              className: "btn btn-danger btn-xs",
              type: "button",
              style: {
                marginTop: '0.25em'
              },
              onClick: function onClick() {
                return arrayHelpers.remove(index);
              }
            }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
          }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-secondary btn-sm",
            type: "button",
            onClick: function onClick() {
              return arrayHelpers.push('');
            }
          }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
            spaceRight: true
          }), "Add email address")));
        }
      }))), values.subscriberType === 'sms' && /*#__PURE__*/_react["default"].createElement("div", {
        className: "card border-primary mb-3"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-header text-bg-primary"
      }, "Receiver List (", values.phones.length, ")"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-body"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
        name: "phones",
        render: function render(arrayHelpers) {
          return /*#__PURE__*/_react["default"].createElement("div", null, values.phones.map(function (item, index, arr) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: index,
              className: _style["default"].block
            }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "phones.".concat(index),
              component: _cccisdFormik.CccisdInput,
              label: "",
              autoFocus: index === arr.length - 1,
              style: {
                width: '10em'
              }
            }), /*#__PURE__*/_react["default"].createElement("button", {
              className: "btn btn-danger btn-xs",
              type: "button",
              style: {
                marginTop: '0.25em'
              },
              onClick: function onClick() {
                return arrayHelpers.remove(index);
              }
            }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
          }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-secondary btn-sm",
            type: "button",
            onClick: function onClick() {
              return arrayHelpers.push('');
            }
          }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
            spaceRight: true
          }), "Add phone")));
        }
      }))), /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit"
      }, "Submit"));
    }
  });
};
FlagForm.propTypes = {
  initialValues: _propTypes["default"].object,
  onSubmit: _propTypes["default"].func,
  closeModal: _propTypes["default"].func
};
FlagForm.defaultProps = {};
var _default = exports["default"] = FlagForm;